import type { ProductViewModel } from '@jane/bloom/viewModels/productDetail';

/**
 * @see https://ogp.me/
 */
export const openGraph = (product?: ProductViewModel) => {
  if (!product) return {};
  return [
    {
      content: product.name,
      property: 'og:title',
    },
    {
      content: product.description,
      property: 'og:description',
    },
    {
      content: product.base_image,
      property: 'og:image',
    },
  ];
};
